import React from 'react';
import PropTypes from 'prop-types';

import Icon from '../Icon/Icon';

import * as styles from './ArticleMeta.module.scss';

const propTypes = {
  /**
   * Date content
   */
  date: PropTypes.string,

  /**
   * Time to read content
   */
  readingTime: PropTypes.string,

  /**
   * Additional classname
   */
  classname: PropTypes.string,

  /**
   * Datetime content
   */
  datetime: PropTypes.string
};

/**
 * Date component
 */
const ArticleMeta = ({
  date,
  readingTime,
  datetime,
  classname
}) => {
  if (!date && !readingTime) {
    return false;
  }

  return (
    <div className={`${styles.root} ${classname || null}`}>
      {date && <time dateTime={datetime || null} className={styles.rootDate}>{date}</time>}
      {readingTime && <div className={styles.rootReadingTimeWrapper}>
        <Icon classname={styles.rootReadingTimeIcon} name='readingTime' size={{
          width: 15,
          height: 15
        }}/>
        <span className={styles.rootReadingTime}>{readingTime} min</span>
      </div>}
    </div>
  );
};

ArticleMeta.propTypes = propTypes;

export default ArticleMeta;
